import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

export default function DeleteModal(
    props: {
        action: string,
        type: 'Object',
        onCancel: () => void,
        onConfirm: () => void,
        open: boolean
    } = {
        open: false
    }
) {
    return (
        <Modal open={props.open} size="small">
            <Modal.Header content={`${props.action || 'Delete'} ${props.type}`} />
            <Modal.Content
                content={`Are you sure you want to ${props.action || 'Delete'} this ${props.type}?`}
            />
            <Modal.Actions>
                <Button content="Cancel" onClick={props.onCancel} />
                <Button content={props.action} onClick={props.onConfirm} primary />
            </Modal.Actions>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./components/molecules/DeleteModal.jsx